// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout Utility Styles
   These styles ensure consistent spacing and layout across the application */

/* Page container with proper header spacing */
.page-container {
  padding-top: 3rem; /* Ensure content starts below fixed header */
  min-height: calc(
    100vh - 3rem
  ); /* Subtract header height for proper min-height */
  width: 100%;
  overflow-x: hidden;
}

/* Grid layouts */
.grid-responsive {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}

/* Spacing utilities */
.section-spacing {
  margin-bottom: 2rem;
}

.content-spacing {
  padding: 1.5rem;
}

/* Form consistency */
.form-group {
  margin-bottom: 1rem;
}

/* Consistent card styles */
.card-hover {
  transition:
    transform 0.2s,
    box-shadow 0.2s;
}

.card-hover:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

/* Consistent button styles */
.btn-animated {
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
}

.btn-animated:hover {
  transform: translateY(-2px);
}

/* Fix for mobile responsive issues */
@media (max-width: 768px) {
  .page-container {
    padding-top: 2.5rem;
  }

  .content-spacing {
    padding: 1rem;
  }

  .responsive-stack {
    flex-direction: column !important;
  }

  .responsive-full-width {
    width: 100% !important;
  }
}

/* Fix overflow issues */
.overflow-fix {
  max-width: 100%;
  overflow-x: hidden;
}

/* Ensure fixed elements don't create overflow */
.fixed-element-container {
  position: relative;
  z-index: 10;
}

/* Consistent form input heights */
.input-height-consistent {
  height: 2.75rem;
}

/* Enhanced horizontal scrolling for tables */
.overflow-x-auto {
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  overflow-x: auto;
  overflow-y: visible;
}

.overflow-x-auto table {
  width: 100%;
  border-collapse: collapse;
  min-width: min-content;
}

.overflow-x-auto::-webkit-scrollbar {
  height: 8px;
}

.overflow-x-auto::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
  margin: 2px;
}

.overflow-x-auto::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.overflow-x-auto::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Responsive table adjustments */
@media (max-width: 768px) {
  .overflow-x-auto {
    -webkit-overflow-scrolling: touch;
    overflow-x: auto;
  }

  .overflow-x-auto table {
    font-size: 12px;
  }

  .overflow-x-auto th,
  .overflow-x-auto td {
    padding: 8px 6px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/layout-utils.css"],"names":[],"mappings":"AAAA;6EAC6E;;AAE7E,8CAA8C;AAC9C;EACE,iBAAiB,EAAE,6CAA6C;EAChE;;GAEC,EAAE,iDAAiD;EACpD,WAAW;EACX,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,4DAA4D;AAC9D;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;;mBAEiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,iCAAiC;EACjC,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE;IACE,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,2BAA2B;EAC7B;AACF","sourcesContent":["/* Layout Utility Styles\n   These styles ensure consistent spacing and layout across the application */\n\n/* Page container with proper header spacing */\n.page-container {\n  padding-top: 3rem; /* Ensure content starts below fixed header */\n  min-height: calc(\n    100vh - 3rem\n  ); /* Subtract header height for proper min-height */\n  width: 100%;\n  overflow-x: hidden;\n}\n\n/* Grid layouts */\n.grid-responsive {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n}\n\n/* Spacing utilities */\n.section-spacing {\n  margin-bottom: 2rem;\n}\n\n.content-spacing {\n  padding: 1.5rem;\n}\n\n/* Form consistency */\n.form-group {\n  margin-bottom: 1rem;\n}\n\n/* Consistent card styles */\n.card-hover {\n  transition:\n    transform 0.2s,\n    box-shadow 0.2s;\n}\n\n.card-hover:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n}\n\n/* Consistent button styles */\n.btn-animated {\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s;\n}\n\n.btn-animated:hover {\n  transform: translateY(-2px);\n}\n\n/* Fix for mobile responsive issues */\n@media (max-width: 768px) {\n  .page-container {\n    padding-top: 2.5rem;\n  }\n\n  .content-spacing {\n    padding: 1rem;\n  }\n\n  .responsive-stack {\n    flex-direction: column !important;\n  }\n\n  .responsive-full-width {\n    width: 100% !important;\n  }\n}\n\n/* Fix overflow issues */\n.overflow-fix {\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n/* Ensure fixed elements don't create overflow */\n.fixed-element-container {\n  position: relative;\n  z-index: 10;\n}\n\n/* Consistent form input heights */\n.input-height-consistent {\n  height: 2.75rem;\n}\n\n/* Enhanced horizontal scrolling for tables */\n.overflow-x-auto {\n  -webkit-overflow-scrolling: touch;\n  scroll-behavior: smooth;\n  overflow-x: auto;\n  overflow-y: visible;\n}\n\n.overflow-x-auto table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: min-content;\n}\n\n.overflow-x-auto::-webkit-scrollbar {\n  height: 8px;\n}\n\n.overflow-x-auto::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n  margin: 2px;\n}\n\n.overflow-x-auto::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.overflow-x-auto::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Responsive table adjustments */\n@media (max-width: 768px) {\n  .overflow-x-auto {\n    -webkit-overflow-scrolling: touch;\n    overflow-x: auto;\n  }\n\n  .overflow-x-auto table {\n    font-size: 12px;\n  }\n\n  .overflow-x-auto th,\n  .overflow-x-auto td {\n    padding: 8px 6px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
